<template>
  <div>
    <BlockTitle class="mb-8 md:mb-16" :subtitle :title />

    <RichText
      v-if="contentText"
      class="body-1 mb-24 whitespace-pre-line"
      :class="[$style.richTextSpacing]"
      :rich-text="contentText"
      style-variant="none"
    />

    <CTALink
      :cta-link
      :tracking="trackingData"
      variant="secondary"
      width="fixed"
    />

    <YoutubeVideoModal
      v-if="ctaVideo"
      class="mt-4 md:mt-12"
      :name="videoModalName"
      :title="ctaVideo?.title"
      :youtube-id="ctaVideo?.id"
    >
      <template #trigger="{ open }">
        <CmsButtonBase
          variant="secondary"
          width="fixed"
          @click="() => openVideoModalAndSendTrackingData(open)"
        >
          {{ ctaVideo?.label }}
        </CmsButtonBase>
      </template>
    </YoutubeVideoModal>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { ContentProps } from '@backmarket/http-api/src/api-specs-content/models/content'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import type { ContentBlockProps as ContentBlockPropsModel } from '../../models/content-block'
import BlockTitle from '../../shared-components/BlockTitle/BlockTitle.vue'
import CTALink from '../../shared-components/CTALink/CTALink.vue'
import CmsButtonBase from '../../shared-components/CmsButtonBase/CmsButtonBase.vue'
import YoutubeVideoModal from '../../shared-components/YoutubeVideoModal/YoutubeVideoModal.vue'
import RichText from '../RichText/RichText.vue'

export type ContentBlockProps = ContentProps & ContentBlockPropsModel

const props = defineProps<ContentBlockProps>()

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])

const { trackClick } = useTracking()

const videoModalName = computed(() => `modal-video-${props.ctaVideo?.id}`)

const trackingData = computed(() => ({
  ...(props.tracking || {}),
  ...(props.title && { blockTitle: props.title }),
}))

function sendTrackingData() {
  trackClick(trackingData.value)
}

function openVideoModalAndSendTrackingData(openVideoModal: () => void) {
  openVideoModal()
  sendTrackingData()
}
</script>

<style module>
.richTextSpacing {
  div {
    @apply flex flex-col gap-12;
  }

  p:nth-last-of-type(1):empty {
    display: none;
  }
}
</style>
